import { config } from '../config';

const VAPID_PUBLIC_KEY = "BEh4bvyAUb7jjPXBERrfZK_F-vdwBhlSU7rqWIctLp2EVVtWFaosLEHtWQf-Aku6Z2o7wKndF7DOP6z32bMVmjU";

// Utility function to convert VAPID key (defined above)
function urlBase64ToUint8Array(base64String) {
    // Implementation as defined in section 1
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

/**
 * Initiates the push subscription process.
 * @param {ServiceWorkerRegistration} registration The service worker registration object.
 * @param {string} driverUsername The unique username/ID of the logged-in driver.
 */
export async function subscribeUserToPush(registration, driverUsername) {
    if (!driverUsername) {
        // console.error("Driver ID is required to save subscription.");
        return;
    }

    const applicationServerKey = urlBase64ToUint8Array(VAPID_PUBLIC_KEY);

    const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: applicationServerKey
    });

    // console.log(subscription);

    const subscriptionJSON = subscription.toJSON();

    // 🚨 NEW: Create the payload including the driver's identifier
    const payload = {
        ...subscriptionJSON,
        driverUsername: driverUsername // Ensure this matches your backend's expected field (username)
    };

    sendSubscriptionToBackend(payload);
}


// ... (keep existing code)

async function sendSubscriptionToBackend(data) {
    try {
        const response = await fetch(`${config.API_BASE_URL}/api/login7/notification`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            // The data now includes driverUsername, endpoint, p256dh, and auth keys
            body: JSON.stringify(data)
        });

        const result = await response.json();

        if (response.ok && result.status === "success") {
            // console.log("Success:", result);
            // alert("Object saved correctly in the database!");
            return true; // Return success status
        } else {
            // console.error("Backend failed:", result);
            alert(`Failed to save subscription: ${result.message || "Unknown error"}`);
            return false; // Return failure status
        }
    } catch (error) {
        // console.error("Error sending data:", error);
        alert("Network error: Could not reach the server.");
        return false; // Return failure status
    }
}




/**
 * Initiates the push subscription deletion process.
 * @param {ServiceWorkerRegistration} registration The service worker registration object.
 * @param {string} driverUsername The unique username/ID of the logged-in driver.
 */
export async function unsubscribeUserToPush(registration, driverUsername) {
    if (!driverUsername) {
        // console.error("Driver ID is required to save subscription.");
        return;
    }

    const applicationServerKey = urlBase64ToUint8Array(VAPID_PUBLIC_KEY);

    const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: applicationServerKey
    });

    // console.log(subscription);

    const subscriptionJSON = subscription.toJSON();

    // 🚨 NEW: Create the payload including the driver's identifier
    const payload = {
        ...subscriptionJSON,
        driverUsername: driverUsername // Ensure this matches your backend's expected field (username)
    };

    sendSubscriptionDeletionToBackend(payload);
}

async function sendSubscriptionDeletionToBackend(data) {
    try {
        const response = await fetch(`${config.API_BASE_URL}/api/login7/deletenotification`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            // The data now includes driverUsername, endpoint, p256dh, and auth keys
            body: JSON.stringify(data)
        });

        const result = await response.json();

        if (response.ok && result.status === "success") {
            // console.log("Success:", result);
            alert("Notification disabled");
            return true; // Return success status
        } else {
            // console.error("Backend failed:", result);
            // alert(`Failed to delete subscription: ${result.message || "Unknown error"}`);
            return false; // Return failure status
        }
    } catch (error) {
        // console.error("Error sending data:", error);
        alert("Network error: Could not reach the server.");
        return false; // Return failure status
    }
}